import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { AppHeader } from '@design-system/app-header';
export const BlockAppHeader = (_a) => {
    var { blockData, blockId, blockQuery, clearFilters, setBlockData, setBlockQuery, setData, setScreenReaderStatus } = _a, appHeaderProps = __rest(_a, ["blockData", "blockId", "blockQuery", "clearFilters", "setBlockData", "setBlockQuery", "setData", "setScreenReaderStatus"]);
    return _jsx(AppHeader, Object.assign({}, appHeaderProps));
};
//# sourceMappingURL=index.js.map